import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { completePendingSocialLogin } from '../../../services/WebSocialAuth';
import { authService } from '../../../services/AuthenticationService';
import { routes } from '../../../route-list';
import { LoadingScreen } from '../../core/LoadingScreen';

export const CallbackContainer: React.FC = () => {
  const history = useHistory();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const tokens = await completePendingSocialLogin();
        if (tokens) {
          await authService.completeSocialLogin(tokens);

          // Guard: social login may create a new account with no portal roles.
          // If the user only has "studier" (or no roles), they were invited with
          // email+password — log them out and redirect back with a clear message.
          const userInfo = authService.getUserInfo();
          const roles: string[] = userInfo?.roles || [];
          const hasPortalAccess = roles.some(r => r !== 'studier');
          if (!hasPortalAccess) {
            authService.logout();
            setError(
              'This email is registered with an email and password account. Please log in using your email and password instead.'
            );
            return;
          }

          history.replace(routes.HOME);
        } else {
          // No code in URL — not a social callback, go to login
          history.replace(routes.LOGIN);
        }
      } catch (e: any) {
        setError(e?.message || 'Sign-in failed. Please try again.');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center', fontFamily: 'Nunito, sans-serif' }}>
          <p style={{ color: '#b03030', marginBottom: 16 }}>{error}</p>
          <button
            style={{ color: '#0038b8', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 700 }}
            onClick={() => history.push(routes.LOGIN)}>
            Back to login
          </button>
        </div>
      </div>
    );
  }

  return <LoadingScreen />;
};
